import { useQuery } from "@apollo/client";
import { FREQUENCY_QUERY } from "../../Routes/frequency/page";
import { StampRow } from "../../Routes/frequency/page";
import { getFrequencyStartIndex } from "../../utils/frequency";
import { useNavigate } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";

export default function FrequencyCard() {
  const { data: frequencyData } = useQuery(FREQUENCY_QUERY);

  const stamps = frequencyData?.me?.frequency || [];
  const validStamps = stamps.filter(
    (stamp) => stamp.reason === "ORDER" || stamp.reason === "REVIEW"
  );

  const totalCount = validStamps.length;
  const currentCycleCount = getFrequencyStartIndex(totalCount, 10); // 현재 사이클의 스탬프 개수
  const lastCycleStamps = validStamps.slice(currentCycleCount); // 마지막 사이클의 스탬프들

  // 현재 사이클의 스탬프만 표시하고 나머지는 빈 스탬프(null)로 채움
  const displayStamps = Array.from({ length: 10 }, (_, index) =>
    index < currentCycleCount + 10 ? lastCycleStamps[index] : null
  );

  const navigate = useNavigate();

  return (
    <div className="bg-white mx-4">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">내 스탬프</h2>
        <div
          onClick={() => {
            track("프리퀀시 진입로 클릭", {
              어디서:
                window.location.pathname === "/order"
                  ? "주문내역"
                  : "마이페이지",
            });
            navigate("/frequency");
          }}
          className="text-md text-gray-600"
        >
          모두 보기
        </div>
      </div>

      <div className="rounded-xl border border-blue-100 px-5 pt-6 pb-4 mt-3">
        <StampRow stamps={displayStamps} startIndex={0} />
      </div>
    </div>
  );
}
